import React, { useRef, useState, useEffect } from 'react';
import classnames from 'classnames';
import Navigation from 'components/navigation';
import CanvasView from '../canvasView';

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

const ModulesData = ({ data, result, menu, step, setStep }) => {

  const canvasRef = useRef(null);
  const elRef = useRef(null);
  const [reply, setReply] = useState({});
  const [progress, setProgress] = useState(0);
  const [inspOpt, setOption] = useState(null);

  const [size, setSize] = useState({
    width: 500,
    height: 100
  });

  const [check, setCheck] = useState([]);
  const [next, setNext] = useState(false);
  const [idElem, setNextId] = useState(null);

  const canvas = canvasRef.current;

  const selectedItem = id => {
    
    let sideBar = document.getElementById("sidebarLeft");
    let hghVal = 0;
    for(let i = 0; i <= id; i++) {
      hghVal += sideBar.children[i].clientHeight + 39;
    }
    sideBar.scrollTo({
      top: hghVal,
      behavior: "smooth"
    });

    if (check.includes(id)) {
      setCheck(check.filter(item => item !== id));
    } else {
      setOption(id);
      setCheck([...check, id]);
    }
  };

  useEffect(() => {
    if (result && result[menu + 1] && result[menu + 1][2]) {
      setCheck(result[menu + 1][2]);
    }
  }, []);

  useEffect(() => {
    let mas = [];
    data &&
      data.checkListData_forEachModule[menu].forEach((item, index) => {
        if (item.isRightAnswer) {
          mas.push(index);
        }
      });
    if (
      mas.length === check.length &&
      mas.every(item => {
        return check.includes(item);
      })
    ) {
      setNext(true);
    } else {
      setNext(false);
    }
  }, [check]);



  let elementToDrag = null;
  let elementInfo = data ? data.modulesData[menu].info : '';

  let counterDetailsWrong = 0; 
  window.canvasRef = canvasRef;
  window.modulesData = data.modulesData[menu];

  const updateDragItem = (id, isAuto) => {

    // setNext(true);

    let listItem = document.getElementById('imagesToDrag_List');

    if (listItem) {
      if (isAuto) {
        
        listItem.style.pointerEvents = 'none';
        listItem.style.opacity = '0.4';

        elRef.current = document.getElementById(id);

        if (elRef.current && elRef.current.classList.contains('done')) {
          Array.from(listItem.children).forEach( elem => {
            if ( elem.id < id && !elem.classList.contains('done') ) elRef.current = elem;
          });
        }

      } else {
        listItem.style.pointerEvents = 'auto';
        listItem.style.opacity = '1';
      }
    }

      const gameInfo = document.getElementById('gameInfo');
      // console.log('updateDragItem0', id, elRef.current );

      if (elRef.current && elRef.current.id && id && id !== 'wrong' ) {

          elRef.current.style.position = 'static';
          elRef.current.style.transform = 'translate(0, 0)';
          elRef.current.classList.add('done');
          // console.log('updateDragItem1', id, elRef.current, isAuto, reply );

          if (data && data.modulesData[menu].imagesTitels) {
            elementInfo = data.modulesData[menu].imagesTitels[+id - 1];
            // console.log('elementInfo', elementInfo );
            setNextId(+id - 1);
            document.getElementById('infoData').innerHTML = elementInfo;
          }

          var el = document.getElementById('imagesToDrag_List').children;
          var arrElems = Array.prototype.slice.call( el );
          
          let isAllDone = arrElems.filter( (elem) => !elem.classList.contains('done') );
          if (!isAllDone.length) {
            arrElems.forEach( (elem) => elem.classList.add('complete') );
            gameInfo.classList.add('complete');
          }

          if (gameInfo.classList.contains('advice'))    gameInfo.classList.remove('advice');
          if (gameInfo.classList.contains('construct')) gameInfo.classList.remove('construct');
          if (gameInfo.classList.contains('wrong'))     gameInfo.classList.remove('wrong');
          
          updateImagesList(false);
          counterDetailsWrong = 0;

        setReply({ ...reply, [elRef.current.id]: { x: 0, y: 0 } });

      } else if (elRef.current && id && id === 'wrong') {
          elRef.current.style.position = 'static';
          elRef.current.style.transform = 'translate(0, 0)';

          // console.log('wrong', counterDetailsWrong);
          counterDetailsWrong++;

          if (counterDetailsWrong < 3) {

            if (!gameInfo.classList.contains('wrong')) {
              gameInfo.classList.add('wrong');
              // console.log('gameInfo.classList', gameInfo.classList);
              if (gameInfo.classList.contains('advice')) gameInfo.classList.remove('advice');
              if (gameInfo.classList.contains('construct')) gameInfo.classList.remove('construct');
              setTimeout(()=>{gameInfo.classList.remove('wrong');}, 1400);
            }

          } else {
            updateImagesList('muted');
            gameInfo.classList.add('advice');
          } 

      } else if (elRef.current) {
          elRef.current.style.position = 'static';
          elRef.current.style.transform = 'translate(0, 0)';
      }

  };

  const updateImagesList = (option) => {
    const imagesList = document.getElementById('imagesToDrag_List');
    
    if (option === 'muted') {
      // console.log('option', option, imagesList);
      // console.log('pointIndex imageNameCurrent', canvas.pointIndex, canvas.imageNameCurrent );
      let notFirstElem;

      Array.from(imagesList.children).forEach( (elem, index) => {

          if (!elem.classList.contains('done')) {
            elem.classList.add('moving');
            if (elem.dataset.name.toLowerCase().replace(new RegExp(" ",'g'),"_") !== canvas.imageNameCurrent) {
              elem.classList.add('muted');
              elem.classList.remove('moving');
            } else if (elem.dataset.name.toLowerCase().replace(new RegExp(" ",'g'),"_") === canvas.imageNameCurrent && notFirstElem ) {
              elem.classList.add('muted');
              elem.classList.remove('moving');
            } else {
              notFirstElem = true;
            }
          }

      });

    } else {
      Array.from(imagesList.children).forEach( (elem) => {
        if ( elem.classList.contains('muted') )  elem.classList.remove('muted'); 
        if ( elem.classList.contains('moving') ) elem.classList.remove('moving');
      });
    }

  };


  const handleMouseDownn = e => {

    elementToDrag = e.currentTarget.dataset;
    canvasRef.current.setFragElement({id: elementToDrag.id, name: elementToDrag.name, callback: updateDragItem});

    if ( e.currentTarget.classList.contains('moving') ) e.currentTarget.classList.remove('moving');

    elRef.current = e.currentTarget;
    e.currentTarget.style.position = 'absolute';
    e.currentTarget.style.transform = 'translate(-50%, -50%)';

    //console.log('elRef.current', elRef.current.id );

    moveAt(e);
  };

  const moveAt = e => {
    if (elRef.current) {
      elRef.current.style.top = e.pageY + 'px';
      elRef.current.style.left = e.pageX + 'px';
    }



  };

  const updDetInfo = e => {
    if (e === 'adviceConstruct') {
            // const gameInfo = document.getElementById('gameInfo');
            // updateImagesList('muted');
            // gameInfo.classList.add('construct');
    } else {
      if (canvasRef.current && canvasRef.current.detailInfoSel !== null) {
          const infoDataDetail = document.getElementById('infoData');
          infoDataDetail.innerHTML = data.modulesData[menu].imagesTitels[canvasRef.current.detailInfoSel];
          console.log('detailInfoSel', data.modulesData[menu].imagesTitels[canvasRef.current.detailInfoSel] );
      }
    }
  };

  const handleMouseUp = e => {

    if (!elRef.current) return;

    elRef.current.style.position = 'static';
    elRef.current.style.transform = 'translate(0, 0)';

    const rect = canvas.renderer.domElement.getBoundingClientRect();
    const newLocation = { x: e.pageX - rect.left, y: e.pageY - rect.top };

    console.log(e.currentTarget, reply);
    canvasRef.current.setFragElement({id: null, name: null });

    if ( newLocation.x >= 0 && newLocation.y >= 0  ) {
      if (elRef.current.id) {
        setReply({ ...reply, [elRef.current.id]: newLocation });
      }
    }

    elRef.current = null;
  };

  const onWindowResize = () => {
    setSize({
      width:  canvasRef.current.clientWidth,
      height: canvasRef.current.clientHeight,
    });
  };

  const backToMenu = () => {
    setStep(1);
  };

  useEffect(() => {
    if (result && result[menu + 1] && result[menu + 1][1]) {
      setReply(result[menu + 1][1]);
    }
    if (data) {
      let temp = 0;
      for (let key in result) {
        if (result[key].type === 'menu') {
          temp = temp + (Object.keys(result[key]).length - 1);
        } else {
          temp++;
        }
      }
      let dataTemp =
        Object.keys(data.modulesData).length +
        Object.keys(data.checkListData_forEachModule).length +
        3;
      setProgress(Math.round((temp / dataTemp) * 100));
    }
    onWindowResize();
    document.addEventListener('mousemove', e => moveAt(e));
    return () => {
      document.removeEventListener('mousemove', e => moveAt(e));
    };
  }, []);


  useEffect(() => {
    if ( step === 2 && Object.getOwnPropertyNames(reply).length === (data && data.modulesData[menu].imagesToDrag.length) ) {
      console.log('useEffect next true');  
      setNext(true);
    } else if ( step === 2 && elRef.current && elRef.current.id == data.modulesData[menu].imagesToDrag.length ) {
      console.log('elRef.current id repl true'); 
      setNext(true);
    }
    console.log('useEffect next false', step, reply, elRef.current, 
    Object.getOwnPropertyNames(reply).length, data.modulesData[menu].imagesToDrag.length);
    //if (elRef.current)  console.log('id check', step, elRef.current.id === data.modulesData[menu].imagesToDrag.length );

  }, [reply]);
// "Raahaa ja yhdistä tuotteet oikeassa järjestyksessä punaisella merkittyyn kohtaan",

  function GameInfo(props) {
    const {step, elementInfo, checkInfo, startMessage, idElem, inspectOption} = props;

    if (step === 2) {
      if (idElem !== null) {
        return <div id="infoData" className="messages infoData">{elementInfo[idElem]}</div>;
      } else {
        return <div id="infoData" className="messages infoData">{startMessage}</div>;
      }
    } else if (step === 3) {
      // console.error(inspectOption, checkInfo );
      // if (inspectOption)   console.error( data.checkListData_forEachModule[menu][inspectOption].info );
      //  && data.checkListData_forEachModule[menu][inspectOption].info
      if (inspectOption !== null) {
        return <div id="infoData" className="messages infoData">{data.checkListData_forEachModule[menu][inspectOption].info}</div>;
      } else { return <div id="infoData" className="messages infoData">{checkInfo}</div>; }
    }

    
  }

  return (
    <div className="modulesData-wrapper">
      <h1 className="titile-step">
        {step === 2 && menu + 1 + '. ' + data.modulesData[menu].title}
        {step === 3 && data.modulesData[menu].title_inspect}
      </h1>

      <div className="btn-wrapper">
          <button onClick={backToMenu} className="btn">{data.mainMenu.title}</button>
      </div>

      <Navigation
        step={step}
        setStep={setStep}
        next={next}
        answer= { step === 2 ? {menu: menu + 1, answ: {1: reply}} : {menu: menu + 1, answ: {2: check.map(item => item + 1)}} }
      />


      <h2 className="step-number"></h2>
      <div className="modulesData-container">

      { step === 2 && 
        <div className="sidebar" id="sidebarLeft">

        { !next &&   
          <div className="imagesToDrag_Title">
            {data && data.modulesDataMessages.imagesToDrag_Title}
          </div>
        }
        { next &&   
          <div className="imagesToDrag_Title" style={{textAlign: "center"}}>
            {data && data.modulesDataMessages.imagesToDrag_Title_complete}
          </div>
        }

          <div className="imagesToDrag_List" id="imagesToDrag_List"> 
          {data && data.modulesData[menu].imagesToDrag.map((item, index) => (
              <div
                key={index}
                id={index + 1}
                data-id={index + 1}
                data-info={index + 1}
                data-name={data.modulesData[menu].imagesNames[index]}
                className="imagesToDrag-wrapper"
                onMouseDown={handleMouseDownn}
                onMouseUp={handleMouseUp}
              >
                <img
                  src={item}
                  className="imagesToDrag"
                  onDragStart={e => {
                    e.preventDefault();
                  }}
                  alt="imagesToDrag"
                />
                <div className="name">{ data.modulesData[menu].imagesNames[index] }</div>
              </div>
            ))}
            </div>

          <div className="progress">
            <div className="text">{progress + '%'}</div>
            <div className="progress-bg" style={{ width: progress + '%' }}>
              {' '}
            </div>
          </div>
        


        </div>
     }

     { step === 3 && 
        <div className="sidebar check" id="sidebarLeft">
   
          {data && data.checkListData_forEachModule[menu].map((item, index) => (
              <div key={index} className="sidebar-list">
                <div
                  className={ classnames('checkbox', {
                    'checkbox-check': check.includes(index),
                  })}
                  onClick={() => selectedItem(index)}
                ></div>
                <div className="text">{index + 1 + '. ' + item.title}</div>
              </div>
          ))}

        </div>
     }


        <div className="game-zone">

          <div className="canvas-wrapper">
            <CanvasView 
              ref={canvasRef} 
              width={size.width} 
              height={size.height}
              model={data && data.modulesData[menu].canvasData.modelUrl}
              elementsNames = {data && data.modulesData[menu].imagesNames}
              autoIndexes = {data && data.modulesData[menu].autoIndexes}
              putTogether = {data && data.modulesData[menu].putTogether}
              showContruction = {data && data.modulesData[menu].showContruction}
              startPos = {data && data.modulesData[menu].startPos}
              cameraBehavior = {data && data.modulesData[menu].isWatchCamera}
              camPosOnCheck = {data && data.checkListData_forEachModule[menu]}
              inspOpt = {inspOpt}
              updateDetInfo = {updDetInfo}
              step={step}
            />
          </div>

          <div className="game-info" id="gameInfo">

            <GameInfo 
            step={step} 
            elementInfo={data.modulesData[menu].imagesTitels} 
            checkInfo={data.modulesData[menu].info}
            startMessage={data && data.modulesData[menu].startMessage}
            idElem={idElem}
            inspectOption={inspOpt} 
            />

            <div className="messages warningData">
              <img src="assets/icons/error.svg" alt="warning"/>
              <p className="messagesPar warnMessage">{data && data.modulesDataMessages.error}</p>
            </div>

            <div className="messages adviceData">
              <img src="assets/icons/error.svg" alt="warning"/>
              <p className="messagesPar adviseMessage">{data && data.modulesDataMessages.warning}</p>
            </div>

            {/* <div className="messages constructData">
              <img src="assets/icons/warn.svg" alt="warning"/>
              <p className="messagesPar constructMessage">Please put the "Sleeve Joint no 70"</p>
            </div> */}

            <div className="messages completeData">
              <p className="completeMessage">{data && data.modulesData[menu].complete}</p>
            </div>
          </div>
             
        </div>

      </div>


    </div>


  );
};

export default ModulesData;
